import React from "react";
import { IconBaseProps } from "react-icons";
import { Box, Button, Flex, Heading, Text } from "rebass";

interface IProps {
  providerName: string;
  icon: React.FC<IconBaseProps>;
  onClick(): void;
}

export const ConnectPlaceholder: React.FC<IProps> = ({ providerName, icon: Icon, onClick }) => (
  <Box width="50%">
    <Flex justifyContent="center">
      <Icon
        size={60}
        display="block"
      />
    </Flex>

    <Heading
      as="h4"
      mt="25px"
      fontSize="18px"
      fontWeight={500}
      textAlign="center"
      color="zodiac"
    >
      Upload a file from {providerName}
    </Heading>

    <Text
      as="p"
      mt="10px"
      lineHeight="1.44"
      fontSize="16px"
      fontWeight={500}
      textAlign="center"
      color="#b6b9ce"
    >
      <span>We'll open a new page to help you</span>

      <br />

      <span>connect to your {providerName} account</span>
    </Text>

    <Flex
      justifyContent="center"
      mt="20px"
    >
      <Button
        type="button"
        bg="#0162ff"
        onClick={onClick}
      >
        <Text
          fontSize="16px"
          fontWeight={500}
        >
          Connect to {providerName}
        </Text>
      </Button>
    </Flex>
  </Box>
);
